import { disableInput, elementDisplay } from "../../../utils/elementControl";
import { subCatInputOnChange } from "./claimDetailUtils";
import { isElementVisible } from "../../../utils/elementControl";
import { getObjectClaimUserInfo } from "../../../utils/localStorage/localStorage";

const isNullOrEmpty = (value: any): boolean => value == null || value.toString() === '' || value === undefined;

const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;
const objRequestor = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;
const company_code = !isNullOrEmpty(objRequestor)  ? objRequestor.company_code : null;
let Taxcode1 = '', Taxcode2 = '', Taxcode3 = '', Taxcode4 = '';
let isValue = false;

const normalizeTaxOptionText = (value: any): string | null => {
    const text = (value ?? '').toString().replace(/%/g, '').replace(/,/g, '').trim();
    return text === '' || text === 'undefined' || text === 'null' ? null : text.toLowerCase();
};

const normalizeTaxOptionRate = (value: any): string | null => {
    const text = normalizeTaxOptionText(value);
    if (text === null) {
        return null;
    }

    const numericValue = Number(text);
    return Number.isFinite(numericValue) ? numericValue.toString() : text;
};

const matchesTaxCompanyCode = (configuredCompanyCode: any, requestedCompanyCode: any): boolean => {
    const configuredCode = normalizeTaxOptionText(configuredCompanyCode);
    const requestedCode = normalizeTaxOptionText(requestedCompanyCode);
    return configuredCode === 'all' || configuredCode === requestedCode;
};

export function findVatOption(options: any[] | null | undefined, ...values: any[]) {
    const availableOptions = options ?? [];

    for (const value of values) {
        const normalizedValue = normalizeTaxOptionText(value);
        const normalizedRate = normalizeTaxOptionRate(value);

        if (normalizedValue === null) {
            continue;
        }

        const matchedOption = availableOptions.find((option: any) => {
            const optionValue = normalizeTaxOptionText(option?.value);
            const optionTaxCode = normalizeTaxOptionText(option?.data_taxcode);
            const optionRate = normalizeTaxOptionRate(option?.value);
            const optionLabelRate = normalizeTaxOptionRate(option?.label);

            return normalizedValue === optionValue
                || normalizedValue === optionTaxCode
                || (normalizedRate !== null && (normalizedRate === optionRate || normalizedRate === optionLabelRate));
        });

        if (matchedOption) {
            return matchedOption;
        }
    }

    return undefined;
}

const isExpReportModule = (): boolean => window.location.href.includes("ExpReport");

const getActiveClaimUserInfo = () => getObjectClaimUserInfo();

const getDECountryCode = (requestor: any, attachment: any): string => {
    if (isExpReportModule() && attachment?.country) {
        const activeClaimUser = getActiveClaimUserInfo();
        if (activeClaimUser?.country_code) {
            return activeClaimUser.country_code;
        }
        return requestor?.country_code ?? '';
    }

    const activeClaimUser = getActiveClaimUserInfo();
    if (activeClaimUser?.country_code) {
        return activeClaimUser.country_code;
    }
    return requestor?.country_code ?? '';
};

const getDECompanyCode = (requestor: any, attachment: any): string => {
    if (isExpReportModule() && attachment?.company_code) {
        return attachment.company_code;
    }
    return requestor?.company_code ?? '';
};

const getDECurrencyCode = (requestor: any, attachment: any): string => {
    if (isExpReportModule() && attachment?.foreign_currency) {
        return attachment.foreign_currency;
    }
    return requestor?.currency_code ?? '';
};


export function bindDDLVATforDE(
    display_id: string,
    objtaxratechk: any, 
    display_number:number, 
    category_id:number | null | undefined, 
    company_code:string, 
    range:string,
    detailTypeId :number | null | undefined,
    inputValues: { [key: string]: any | undefined },
    handleBindDDL: (id: string, value?: any) => void) 
{
    handleBindDDL(`${display_id}`, []);
    let arrItem:any[] = [];

    objtaxratechk.forEach((d:any, ind:any) => {
    // $(objtaxratechk).each(function (ind, d) {
        // //console.log("debug objtaxratechk");
        // console.log(objtaxratechk);
        // console.log(ind);
        if (inputValues[`form_mode`] && (inputValues[`form_mode`].toString().toLowerCase() == "edit" || inputValues[`form_mode`].toString().toLowerCase() == "new")) {

            if (objtaxratechk[ind].expiryDate) {
                let expDate = new Date(objtaxratechk[ind].expiryDate);

                let currentDate = new Date();

                if (expDate < currentDate) {
                    return;
                }
            }
        }

        // const dataItem: DataItemPDLocation[] = dataList.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
        //     return {
        //     currency_code: item.currency_code,
        //     location_type: item.location_type,
        //     value: item.entitlement_amount,
        //     label: item.loaction_text,
        //     };
        // });
        // const arrItem = Array.from(new Set(dataItem.map(item => JSON.stringify(item))))
        //     .map(str => JSON.parse(str) as DataItemPDLocation);

        // arrItem.unshift({
        //     currency_code: "",
        //     location_type: "",
        //     value: "",
        //     label: "",
        // });

        if (d.subcategory_id == category_id && matchesTaxCompanyCode(d.companyCode, company_code) && objtaxratechk[ind].range == range) {
            if (d.group_Number == display_number) {
               if (detailTypeId && detailTypeId > 0 && d.detail_id == detailTypeId) {
                   //$(display_id).append($('<option></option>').attr('value', d.group_Number).attr('label', d.rate + '%').attr('data-taxcode', objtaxratechk[i].taxCode).html(d.rate));
                   arrItem.push(
                        {
                            value: d.rate?.toString().replace('%', '').trim(),
                            label: d.rate + '%',
                            data_taxcode: objtaxratechk[ind].taxCode,
                        }
                   ) 
                }
                else if (detailTypeId == 0) {
                   //$(display_id).append($('<option></option>').attr('value', d.group_Number).attr('label', d.rate + '%').attr('data-taxcode', objtaxratechk[i].taxCode).html(d.rate));
                    arrItem.push(
                        {
                            value: d.rate?.toString().replace('%', '').trim(),
                            label: d.rate + '%',
                            data_taxcode: objtaxratechk[ind].taxCode,
                        }
                    ) 
                }

            }

        }

        

    });
    handleBindDDL(`${display_id}`, arrItem);
    return arrItem;
}


export function calculate_Tax_for_DE(
    id_n: number | undefined, 
    isOnLoad: number | null | undefined, 
    eventFire:boolean | null | undefined,
    taxControlName:string | null | undefined,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objAttachment: any
) {
    // Saber Amendment [SR-968218] 20260611
    const parseAmount = (value: any) => {
        const amount = parseFloat((value ?? 0).toString().replace(/,/g, ''));
        return Number.isFinite(amount) ? amount : 0;
    };

    let normal_Base_Amt = 0;
    let reduced_Base_Amt = 0;
    let exempted_Base_Amt = 0;
    let fourth_Base_Amt = 0;

    if (!isNullOrEmpty(inputValues[`txtDENormalBaseAmount${id_n}`]) &&  (inputValues[`txtDENormalBaseAmount${id_n}`] > 0 || inputValues[`txtDENormalBaseAmount${id_n}`] < 0)) {
         normal_Base_Amt = inputValues[`txtDENormalBaseAmount${id_n}`];
    }

    if (!isNullOrEmpty(inputValues[`txtDEReducedBaseAmount${id_n}`]) && (inputValues[`txtDEReducedBaseAmount${id_n}`] > 0 || inputValues[`txtDEReducedBaseAmount${id_n}`] < 0)) {
        reduced_Base_Amt = inputValues[`txtDEReducedBaseAmount${id_n}`]; 
    }

    if (!isNullOrEmpty(inputValues[`txtDEExemptedBaseAmount${id_n}`]) && (inputValues[`txtDEExemptedBaseAmount${id_n}`] > 0 || inputValues[`txtDEExemptedBaseAmount${id_n}`] < 0)) {
         exempted_Base_Amt = inputValues[`txtDEExemptedBaseAmount${id_n}`];
    }

    if (!isNullOrEmpty(inputValues[`txtDEFourthBaseAmount${id_n}`]) && (inputValues[`txtDEFourthBaseAmount${id_n}`] > 0 || inputValues[`txtDEFourthBaseAmount${id_n}`] < 0)) {
         fourth_Base_Amt = inputValues[`txtDEFourthBaseAmount${id_n}`]; 
    }


    let base_Amt = parseAmount(normal_Base_Amt) + parseAmount(reduced_Base_Amt) + parseAmount(exempted_Base_Amt) + parseAmount(fourth_Base_Amt);

    if (eventFire === undefined) {
        eventFire = false;
    }

    if (isOnLoad === undefined) {
        isOnLoad = 0;
    }

    //console.log("debug : base_Amt : " + base_Amt);
     if (isValue) {
        disableInput(`#txtClaimAmount${id_n}`, true, "text");
    }
     else {
         if (objAttachment.iS_CC != "1"){
            disableInput(`#txtClaimAmount${id_n}`, false, "text");
         }
    }
    if (objAttachment.iS_CC != "1") {
        if (isValue) {
            handleInputChange(`txtClaimAmount${id_n}`,base_Amt);
            subCatInputOnChange(
                inputValues,
                id_n,
                "txtClaimAmount",
                handleInputChange,
                base_Amt,
            );
        }
        else {
            if (isOnLoad == 1 && isValue == false) {
                //do nothing when it is loading and no value
            }
            else
            {
                handleInputChange(`txtClaimAmount${id_n}`,base_Amt);
                subCatInputOnChange(
                    inputValues,
                    id_n,
                    "txtClaimAmount",
                    handleInputChange,
                    base_Amt
                );            
            }
        }
    }
    else {
        let reciept_amt = inputValues[`txtClaimAmount${id_n}`];
        if (parseAmount(base_Amt).toFixed(2) != parseAmount(reciept_amt).toFixed(2)) {
            handleInputChange(`hidValidate_CC_DE_Tax`, 1);
        }
        else
            handleInputChange(`hidValidate_CC_DE_Tax`, 0);

        if (!isElementVisible('#divDE_NormalTax' + id_n) &&
            !isElementVisible('#divDE_ReducedTax' + id_n) &&
            !isElementVisible('#divDE_ExemptedTax' + id_n) &&
            !isElementVisible('#divDE_FourthTax' + id_n))
         { handleInputChange(`hidValidate_CC_DE_Tax`, 0);}
    }
    // End Saber Amendment [SR-968218] 20260611
    handleInputChange(`hidden_Init_claim_Amount`, 0);
     
    if (eventFire && taxControlName != "") {

        if (taxControlName == "ddlNormalVAT") {
            Taxcode1 = inputValues[`${taxControlName}${id_n}_taxcode`];
        }

        if (taxControlName == "ddlReducedVAT") {
            Taxcode2 = inputValues[`${taxControlName}${id_n}_taxcode`];
        }

        if (taxControlName == "ddlExemptedVAT") {
            Taxcode3 = inputValues[`${taxControlName}${id_n}_taxcode`];
        }

        if (taxControlName == "ddlFourthVAT") {
            Taxcode4 = inputValues[`${taxControlName}${id_n}_taxcode`];
        }
    }

    if (normal_Base_Amt == 0){
        handleInputChange(`hidTaxcode1${id_n}`, '');
    }
    else{
        handleInputChange(`hidTaxcode1${id_n}`, Taxcode1);
    }
    if (reduced_Base_Amt == 0){
        handleInputChange(`hidTaxcode2${id_n}`, '');
    }
    else{
        handleInputChange(`hidTaxcode2${id_n}`, Taxcode2);
    }
    if (exempted_Base_Amt == 0){
        handleInputChange(`hidTaxcode3${id_n}`, '');
    }
    else{
        handleInputChange(`hidTaxcode3${id_n}`, Taxcode3);
    }
    if (fourth_Base_Amt == 0){
        handleInputChange(`hidTaxcode4${id_n}`, '');
    }
    else{
        handleInputChange(`hidTaxcode4${id_n}`, Taxcode4);
    }
}

export async function enableTaxDetailsForDE(
    //id_n: number | undefined, 
    //Begin saber,20251023, 834984 ensure the ID is correct numeric and not object
    id_n: number | undefined, 
    category: number | null | undefined,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objRequestor: any, 
    objAttachment: any, 
    bindDDL: { [key: string]: any | undefined },
    handleBindDDL: (id: string, value?: any) => void,
    isOnLoad?: number | null | undefined, 
    detailTypeId?:number | null | undefined,
) {
	  // Read fresh from localStorage on each invocation to avoid stale module-level cache on first load
    // (module-level constants are evaluated once at import time, before async data may be available)
    const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;
	const deCountryCode = getDECountryCode(objRequestor, objAttachment);
    const company_code = getDECompanyCode(objRequestor, objAttachment);
																								  
    elementDisplay(`#divDE_NormalTax${id_n}`, false, "div");
    elementDisplay(`#divDE_ReducedTax${id_n}`, false, "div");
    elementDisplay(`#divDE_ExemptedTax${id_n}`, false, "div");
    elementDisplay(`#divDE_FourthTax${id_n}`, false, "div");

    handleBindDDL(`normalVatDDL`, []);
    handleBindDDL(`reducedVatDDL`, []);
    handleBindDDL(`exemptedVatDDL`, []);
    handleBindDDL(`fourthVatDDL`, []);

     if (isNullOrEmpty(detailTypeId)) { 
        detailTypeId = category == 4 ? inputValues[`ddlTransportType${id_n}`] : category == 26 ? inputValues[`ddlPhoneType${id_n}`] : 0; 
    }

    if (isNullOrEmpty(isOnLoad)) {
        isOnLoad = 0; 
    }

     // Saber Amendment [SR-968218] 20260611
     let Cur = inputValues[`ddlCurrency${id_n}`];
    const effective_currency_code = getDECurrencyCode(objRequestor, objAttachment);
    if (isNullOrEmpty(Cur)) {
        Cur = effective_currency_code;
    }

    let range = '';
    let ddl = [];
    let normalVatDDL = [];
    let reducedVatDDL = [];
    let exemptedVatDDL = [];
    let fourthVatDDL = [];
    let normalVatDefault = '';
    let reducedVatDefault = '';
    let exemptedVatDefault = '';
    let fourthVatDefault = '';
    let normal_Base_Amt = 0;
    let reduced_Base_Amt = 0;
    let exempted_Base_Amt = 0;
    let fourth_Base_Amt = 0;

    if (Cur == effective_currency_code) {
        range = 'Local';
    } else {
        range = 'Abroad';
    }
    // End Saber Amendment [SR-968218] 20260611

    //console.log("debug : category :" + category);
    //console.log("debug : detailTypeId :" + detailTypeId);
    //console.log("debug : isOnLoad :" + isOnLoad);

    // let checkProcess = false, isProcess = false; 
    // if ((category == 4 || category == 26) && (detailTypeId && detailTypeId > 0)) {
    //     checkProcess = true;
    // }
    // else if (category != 4 && category != 26 && (detailTypeId && detailTypeId == 0)){
    //     checkProcess = true;
    // }  

    //saber,20251023
    let checkProcess = false, isProcess = false;
    if ((category == 4 || category == 26) && (detailTypeId && detailTypeId > 0)) {
        checkProcess = true;
    }
    // BEFORE (buggy): else if (category != 4 && category != 26 && (detailTypeId && detailTypeId == 0)) { checkProcess = true; }
    // AFTER: allow non-4/26 categories to proceed when no detail type is required (0/empty)
    else if (category != 4 && category != 26 && detailTypeId == 0) {
        checkProcess = true;
    }
    //console.log("debug : checkProcess :" + checkProcess);
    //console.log("debug : range :" + range);
    //console.log("debug : company_code :" + company_code);

    if (checkProcess) {
       if (objtaxratechk) {
            if (objtaxratechk.length) {
                for (let j = 0; j < objtaxratechk.length; j++) {

                    isProcess = false;

                    if (detailTypeId && detailTypeId > 0) {
                        if (objtaxratechk[j].subcategory_id == category && matchesTaxCompanyCode(objtaxratechk[j].companyCode, company_code) && objtaxratechk[j].detail_id == detailTypeId && objtaxratechk[j].group_Number > 0 && objtaxratechk[j].range == range) {
                            isProcess = true;
                            //if (!isValue) {
                            //    $('#hidTaxcode1').val('');
                            //    $('#hidTaxcode2').val('');
                            //    $('#hidTaxcode3').val('');

                            //}
                            //console.log("debug : objtaxratechk :");
                            console.log(objtaxratechk[j]);
                        }

                    }
                    else if (detailTypeId == 0) {
                        if (objtaxratechk[j].subcategory_id == category && matchesTaxCompanyCode(objtaxratechk[j].companyCode, company_code) && objtaxratechk[j].group_Number > 0 && objtaxratechk[j].range == range) {
                            isProcess = true;
                           
                            //if (!isValue) {
                            //    $('#hidTaxcode1').val('');
                            //    $('#hidTaxcode2').val('');
                            //    $('#hidTaxcode3').val('');
                            //}

                        }
                    }

                    if (isProcess)
                    {   
                        //console.log("debug : group_Number :");
                        console.log(objtaxratechk[j].group_Number);
                        if (isNullOrEmpty(objtaxratechk[j].group_Number) || objtaxratechk[j].group_Number == 0) {
                            //If configuration has not done then disable Vat Section for Germany
                             if (isNullOrEmpty(inputValues[`hidTaxcode1${id_n}`])) {
                                elementDisplay(`.cc`, false, "div");
                                handleInputChange(`txtDENormalBaseAmount${id_n}`, "0");
                                
                            }

                             if (isNullOrEmpty(inputValues[`hidTaxcode2${id_n}`])) {
                                elementDisplay(`#divDE_ReducedTax${id_n}`, false, "div");
                                handleInputChange(`txtDEReducedBaseAmount${id_n}`, "0");
                            }

                             if (isNullOrEmpty(inputValues[`hidTaxcode3${id_n}`])) {
                                elementDisplay(`#divDE_ExemptedTax${id_n}`, false, "div");
                                handleInputChange(`txtDEExemptedBaseAmount${id_n}`, "0");
                            }

                             if (isNullOrEmpty(inputValues[`hidTaxcode4${id_n}`])) {
                                elementDisplay(`#divDE_FourthTax${id_n}`, false, "div");
                                handleInputChange(`txtDEFourthBaseAmount${id_n}`, "0");
                             }

                        }

                        else {
                            if (objtaxratechk[j].group_Number == 1) {
                                normalVatDefault = objtaxratechk[j].group_Default ?? '';
                                handleInputChange(`hidNormalVAT_default${id_n}`, objtaxratechk[j].group_Default);
                                elementDisplay(`#divDE_NormalTax${id_n}`, true, "div");
                                if (deCountryCode == "VN") {
                                    elementDisplay(`#lblNormalVAT_VN${id_n}`, true, "div");
                                    elementDisplay(`#lblNormalVAT${id_n}`, false, "div");
                                }
                                else {
                                    elementDisplay(`#lblNormalVAT_VN${id_n}`, false, "div");
                                    elementDisplay(`#lblNormalVAT${id_n}`, true, "div");
                                }
                                handleInputChange(`hidTaxcode1${id_n}`, objtaxratechk[j].taxCode);
                                Taxcode1 = objtaxratechk[j].taxCode;
                                ddl = bindDDLVATforDE('normalVatDDL', objtaxratechk, 1, category, company_code, range, detailTypeId, inputValues, handleBindDDL);
                                normalVatDDL = ddl;
                            }

                            if (objtaxratechk[j].group_Number == 2) {
                                reducedVatDefault = objtaxratechk[j].group_Default ?? '';
                                handleInputChange(`hidReducedVAT_default`, objtaxratechk[j].group_Default);
                                elementDisplay(`#divDE_ReducedTax${id_n}`, true, "div");
                                 
                                          if (deCountryCode == "VN") {
                                   elementDisplay(`#lblReducedVAT_VN${id_n}`, true, "div");
                                   elementDisplay(`#lblReducedVAT${id_n}`, false, "div");
                                }
                                else {
                                    elementDisplay(`#lblReducedVAT_VN${id_n}`, false, "div");
                                    elementDisplay(`#lblReducedVAT${id_n}`, true, "div");
                                }
                                handleInputChange(`hidTaxcode2${id_n}`, objtaxratechk[j].taxCode);
                                Taxcode2 = objtaxratechk[j].taxCode;
                                ddl = bindDDLVATforDE('reducedVatDDL', objtaxratechk, 2, category, company_code, range, detailTypeId, inputValues, handleBindDDL);
                                reducedVatDDL = ddl;
                            }

                            if (objtaxratechk[j].group_Number == 3) {
                                exemptedVatDefault = objtaxratechk[j].group_Default ?? '';
                                handleInputChange(`hidExemptedVAT_default`, objtaxratechk[j].group_Default);
                                elementDisplay(`#divDE_ExemptedTax${id_n}`, true, "div");

                                if (deCountryCode == "VN") {
                                    elementDisplay(`#lblExemptedVAT_VN${id_n}`, true, "div");
                                    elementDisplay(`#lblExemptedVAT${id_n}`, false, "div");
                                }
                                else {
                                    elementDisplay(`#lblExemptedVAT_VN${id_n}`, false, "div");
                                    elementDisplay(`#lblExemptedVAT${id_n}`, true, "div");
                                }
                               
                                handleInputChange(`hidTaxcode3${id_n}`, objtaxratechk[j].taxCode);
                                Taxcode3 = objtaxratechk[j].taxCode;
                                ddl = bindDDLVATforDE('exemptedVatDDL', objtaxratechk, 3, category, company_code, range, detailTypeId, inputValues, handleBindDDL);
                                exemptedVatDDL = ddl;
                            }

                             if (objtaxratechk[j].group_Number == 4) {
                                          fourthVatDefault = objtaxratechk[j].group_Default ?? '';
                                handleInputChange(`hidFourthVAT_default`, objtaxratechk[j].group_Default);
                                elementDisplay(`#divDE_FourthTax${id_n}`, true, "div");

                                            if (deCountryCode == "VN") {

                                    elementDisplay(`#lblFourthTax_VN${id_n}`, true, "div");
                                    elementDisplay(`#lblFourthVAT${id_n}`, false, "div");
                                 }
                                 else {

                                    elementDisplay(`#lblFourthTax_VN${id_n}`, false, "div");
                                    elementDisplay(`#lblFourthVAT${id_n}`, true, "div");
                                 }

                                 handleInputChange(`hidTaxcode4${id_n}`, objtaxratechk[j].taxCode);
                                 Taxcode4 = objtaxratechk[j].taxCode;
                                 ddl = bindDDLVATforDE('fourthVatDDL', objtaxratechk, 4, category, company_code, range, detailTypeId, inputValues, handleBindDDL);
                                 fourthVatDDL = ddl;
                                }

                            // $('#txtClaimAmount' + i).attr("disabled", true);
        // Saber Amendment [SR-968218] 20260611
                                                }
                          ddl = !isNullOrEmpty(normalVatDDL) && normalVatDDL.length > 0 ? normalVatDDL : [];
                if (Math.abs(objAttachment.taxPortion1) > 0 && (isOnLoad && isOnLoad > 0)) {
                    handleInputChange(`txtDENormalBaseAmount${id_n}`, objAttachment.taxPortion1);
                    normal_Base_Amt = objAttachment.taxPortion1;
                    const normalVatRate = !isNullOrEmpty(objAttachment.taxrate1) ? objAttachment.taxrate1 : normalVatDefault;
                    handleInputChange(`ddlNormalVAT${id_n}_text`, normalVatRate);
                    handleInputChange(`ddlNormalVAT${id_n}`, findVatOption(ddl, objAttachment.taxcode1, normalVatRate)?.value ?? "");
                    handleInputChange(`hidTaxcode1${id_n}`, findVatOption(ddl, objAttachment.taxcode1, normalVatRate)?.data_taxcode ?? "");
                    Taxcode1 = findVatOption(ddl, objAttachment.taxcode1, normalVatRate)?.data_taxcode ?? "";
                }
                else {
                    handleInputChange(`txtDENormalBaseAmount${id_n}`, '0');
                    normal_Base_Amt = 0;
                    const selectedNormalVatDefault = normalVatDefault || inputValues[`hidNormalVAT_default${id_n}`] || '';
                    handleInputChange(`ddlNormalVAT${id_n}_text`, selectedNormalVatDefault);
                    handleInputChange(`ddlNormalVAT${id_n}`, findVatOption(ddl, selectedNormalVatDefault)?.value ?? "");
                    handleInputChange(`hidTaxcode1${id_n}`, findVatOption(ddl, selectedNormalVatDefault)?.data_taxcode ?? "");
                    Taxcode1 = findVatOption(ddl, selectedNormalVatDefault)?.data_taxcode ?? "";
                }

                ddl = !isNullOrEmpty(reducedVatDDL) && reducedVatDDL.length > 0 ? reducedVatDDL : [];
                if (Math.abs(objAttachment.taxPortion2) > 0 && (isOnLoad && isOnLoad > 0)) {
                    handleInputChange(`txtDEReducedBaseAmount${id_n}`, objAttachment.taxPortion2);
                    reduced_Base_Amt = objAttachment.taxPortion2;
                    const reducedVatRate = !isNullOrEmpty(objAttachment.taxrate2) ? objAttachment.taxrate2 : reducedVatDefault;
                    handleInputChange(`ddlReducedVAT${id_n}_text`, reducedVatRate);
                    handleInputChange(`ddlReducedVAT${id_n}`, findVatOption(ddl, objAttachment.taxcode2, reducedVatRate)?.value ?? "");
                    handleInputChange(`hidTaxcode2${id_n}`, findVatOption(ddl, objAttachment.taxcode2, reducedVatRate)?.data_taxcode ?? "");
                    Taxcode2 = findVatOption(ddl, objAttachment.taxcode2, reducedVatRate)?.data_taxcode ?? "";
                }
                else {
                    handleInputChange(`txtDEReducedBaseAmount${id_n}`, '0');
                    reduced_Base_Amt = 0;
                    handleInputChange(`ddlReducedVAT${id_n}_text`, reducedVatDefault);
                    handleInputChange(`ddlReducedVAT${id_n}`, findVatOption(ddl, reducedVatDefault)?.value ?? "");
                    handleInputChange(`hidTaxcode2${id_n}`, findVatOption(ddl, reducedVatDefault)?.data_taxcode ?? "");
                    Taxcode2 = findVatOption(ddl, reducedVatDefault)?.data_taxcode ?? "";
                }

                ddl = !isNullOrEmpty(exemptedVatDDL) && exemptedVatDDL.length > 0 ? exemptedVatDDL : [];
                if (Math.abs(objAttachment.taxPortion3) > 0 && (isOnLoad && isOnLoad > 0)) {
                    handleInputChange(`txtDEExemptedBaseAmount${id_n}`, objAttachment.taxPortion3);
                    exempted_Base_Amt = objAttachment.taxPortion3;
                    const exemptedVatRate = !isNullOrEmpty(objAttachment.taxrate3) ? objAttachment.taxrate3 : exemptedVatDefault;
                    handleInputChange(`ddlExemptedVAT${id_n}_text`, exemptedVatRate);
                    handleInputChange(`ddlExemptedVAT${id_n}`, findVatOption(ddl, objAttachment.taxcode3, exemptedVatRate)?.value ?? "");
                    handleInputChange(`hidTaxcode3${id_n}`, findVatOption(ddl, objAttachment.taxcode3, exemptedVatRate)?.data_taxcode ?? "");
                    Taxcode3 = findVatOption(ddl, objAttachment.taxcode3, exemptedVatRate)?.data_taxcode ?? "";
                }
                else {
                    handleInputChange(`txtDEExemptedBaseAmount${id_n}`, '0');
                    exempted_Base_Amt = 0;
                    handleInputChange(`ddlExemptedVAT${id_n}_text`, exemptedVatDefault);
                    handleInputChange(`ddlExemptedVAT${id_n}`, findVatOption(ddl, exemptedVatDefault)?.value ?? "");
                    handleInputChange(`hidTaxcode3${id_n}`, findVatOption(ddl, exemptedVatDefault)?.data_taxcode ?? "");
                    Taxcode3 = findVatOption(ddl, exemptedVatDefault)?.data_taxcode ?? "";
                }

                ddl = !isNullOrEmpty(fourthVatDDL) && fourthVatDDL.length > 0 ? fourthVatDDL : [];
                if (Math.abs(objAttachment.taxPortion4) > 0 && (isOnLoad && isOnLoad > 0)) {
                    handleInputChange(`txtDEFourthBaseAmount${id_n}`, objAttachment.taxPortion4);
                    fourth_Base_Amt = objAttachment.taxPortion4;
                    const fourthVatRate = !isNullOrEmpty(objAttachment.taxrate4) ? objAttachment.taxrate4 : fourthVatDefault;
                    handleInputChange(`ddlFourthVAT${id_n}_text`, fourthVatRate);
                    handleInputChange(`ddlFourthVAT${id_n}`, findVatOption(ddl, objAttachment.taxcode4, fourthVatRate)?.value ?? "");
                    handleInputChange(`hidTaxcode4${id_n}`, findVatOption(ddl, objAttachment.taxcode4, fourthVatRate)?.data_taxcode ?? "");
                    Taxcode4 = findVatOption(ddl, objAttachment.taxcode4, fourthVatRate)?.data_taxcode ?? "";
                }
                else {
                    handleInputChange(`txtDEFourthBaseAmount${id_n}`, '0');
                    fourth_Base_Amt = 0;
                    handleInputChange(`ddlFourthVAT${id_n}_text`, fourthVatDefault);
                    handleInputChange(`ddlFourthVAT${id_n}`, findVatOption(ddl, fourthVatDefault)?.value ?? "");
                    handleInputChange(`hidTaxcode4${id_n}`, findVatOption(ddl, fourthVatDefault)?.data_taxcode ?? "");
                    Taxcode4 = findVatOption(ddl, fourthVatDefault)?.data_taxcode ?? "";
                }
    // End Saber Amendment [SR-968218] 20260611

                    }
                      

                }

                if (isNullOrEmpty(normalVatDDL) || normalVatDDL.length == 0) {
                    elementDisplay(`#divDE_NormalTax${id_n}`, false, "div");
                   
                }

                if (isNullOrEmpty(reducedVatDDL) || reducedVatDDL.length == 0) {
                    elementDisplay(`#divDE_ReducedTax${id_n}`, false, "div");
                     
                }

                if (isNullOrEmpty(exemptedVatDDL) || exemptedVatDDL.length == 0) {
                    elementDisplay(`#divDE_ExemptedTax${id_n}`, false, "div");
                    
                }

                if (isNullOrEmpty(fourthVatDDL) || fourthVatDDL.length == 0) {
                    elementDisplay(`#divDE_FourthTax${id_n}`, false, "div");

                }

                if (!isElementVisible(`#divDE_NormalTax${id_n}`) && !isElementVisible(`#divDE_ReducedTax${id_n}`) && !isElementVisible(`#divDE_ExemptedTax${id_n}`) && !isElementVisible(`#divDE_FourthTax${id_n}`))
                    isValue = false;
                else
                    isValue = true;

              

                 
                calculate_Tax_for_DE
                (
                    id_n,
                    isOnLoad,
                    false,
                    "",
                    { ...inputValues, 
                        ["txtDENormalBaseAmount" + id_n]: normal_Base_Amt,
                        ["txtDEReducedBaseAmount" + id_n]: reduced_Base_Amt ,
                        ["txtDEExemptedBaseAmount" + id_n]: exempted_Base_Amt,
                        ["txtDEFourthBaseAmount" + id_n]: fourth_Base_Amt
                    },
                    handleInputChange,
                    objAttachment
                );
               
            }
           
           
        }

    }

    else {
        disableTaxDetailsForDE(id_n , handleInputChange);
    }

}
//End saber,20251023,INC - 834984 , Displayed Tax Details for DE when no configuration found


export function disableTaxDetailsForDE(
    id_n: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>
    ) 
{

    elementDisplay(`#divDE_NormalTax${id_n}`, false, "div");
    elementDisplay(`#divDE_ReducedTax${id_n}`, false, "div");
    elementDisplay(`#divDE_ExemptedTax${id_n}`, false, "div");
    elementDisplay(`#divDE_FourthTax${id_n}`, false, "div");

    handleInputChange(`txtDEExemptedBaseAmount${id_n}`, '0');
    handleInputChange(`txtDEReducedBaseAmount${id_n}`, '0');
    handleInputChange(`txtDENormalBaseAmount${id_n}`, '0');
    handleInputChange(`txtDEFourthBaseAmount${id_n}`, '0');

    isValue = false;
}